module.exports = __webpack_public_path__ + "static/media/021.936bb710.jpg";